import React, { useRef, useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { storage } from './../../FirebaseUtils';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { collection, onSnapshot, doc, setDoc, deleteDoc, query, where, getDocs } from 'firebase/firestore';
import { firestore } from './../../FirebaseUtils';
import AdminVideoList from './AdminVideoList';
import AdminVideoAssignment from './AdminVideoAssignment';

function AdminVideoSetup() {
    const [ loading, setLoading ] = useState(true);
    const [ errorMessage, setErrorMessage ] = useState();

    const [ uploading, setUploading ] = useState();

    const videoFileRef = useRef();

    const [ videos, setVideos ] = useState([]);

    useEffect(() => {
        // Get a reference to the "questions" collection
        const videosRef = collection(firestore, 'videosDetails');

        // Listen for changes in the collection
        const unsubscribe = onSnapshot(videosRef, (snapshot) => {
            setErrorMessage("");
            setLoading(true);
    
            const videoData = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }));
            setVideos(videoData);

            setLoading(false);
        });

        // Clean up the listener on unmount
        return () => unsubscribe();

    }, []);


    async function onClickUploadButton(e) {

        setUploading(true);

        //for (let i = 0; i < videoFileRef.current.files.length; i++) {
            let file = videoFileRef.current.files[0];
            const selectedFileFullName = file.name;
            let selectedFileExtenstion;

            const now = new Date();
            let cloudFilename = now.getFullYear() + ('0' + (now.getMonth() + 1).toString()).slice(-2) + ('0' + now.getDate()).slice(-2) + ('0' + now.getHours()).slice(-2) + ('0' + now.getMinutes()).slice(-2) + ('0' + now.getSeconds()).slice(-2);

            const dotIndex = selectedFileFullName.lastIndexOf('.');
            if (dotIndex >= 0) {
                selectedFileExtenstion = selectedFileFullName.substr(dotIndex);
            }

            let replace = false;

            try {
                const q = query(collection(firestore, 'videosDetails'), where('filename', '==', selectedFileFullName));
                const querySnapshot = await getDocs(q);
                if (querySnapshot.docs.length > 0) {
                    console.log('Found ', selectedFileFullName, ' in doc: ', querySnapshot.docs[0].id);

                    cloudFilename = querySnapshot.docs[0].id;

                    replace = true;
                } 
                else {
                    console.log('No document found with filename ', selectedFileFullName);
                }
            }
            catch (error) {
                console.log('query fails ', error);

                setUploading(false);
                return;
            }

            try {
                const cloudVideoRef = ref(storage, `${cloudFilename}${selectedFileExtenstion}`);

                if (replace) {
                    console.log('about to delete');
                    await deleteObject(cloudVideoRef);
                }

                const snapshot = await uploadBytes(cloudVideoRef, file);

                var url = await getDownloadURL(cloudVideoRef);
            }
            catch (error) {
                console.log(`Uploading ${selectedFileFullName} failed, error: ${error}`);

                setUploading(false);
                return;
            }

            try {
                var docContent = {
                    filename: selectedFileFullName,
                    ext: selectedFileExtenstion,
                    url: url,
                };
                var docId = cloudFilename;
                await setDoc(doc(firestore, "videosDetails", docId), docContent);
            }
            catch (error) {
                console.log(`Saving ${JSON.stringify(docContent)} to docId:${docId} in firestore fails, error: ${error}`);

                setUploading(false);
                return;
            }
        //}

        setUploading(false);

        // const now = new Date();

        // const filename = now.getFullYear() + ('0' + (now.getMonth() + 1).toString()).slice(-2) + ('0' + now.getDate()).slice(-2) + ('0' + now.getHours()).slice(-2) + ('0' + now.getMinutes()).slice(-2) + ('0' + now.getSeconds()).slice(-2);

        // console.log('videoFileRef.current.files[0].name', videoFileRef.current.files[0].name);

        // const cloudVideoRef = ref(storage, `${videoFileRef.current.files[0].name}`);

        // uploadBytes(cloudVideoRef, videoFileRef.current.files[0]).then((snapshot) => {
        //     console.log('uploaded');
        //     console.log(JSON.stringify(snapshot));

        //     getDownloadURL(cloudVideoRef).then((url) => {
        //         console.log(url);
        //     })
        // });
    }

    return (
        <div>
            <h1>Video Setup</h1>
            {
                loading ?
                    <h1>loading...</h1>
                :
                    uploading ?
                        <div>Uploading... please wait...</div>
                    :
                        <div>
                            <div>Upload</div>
                            <div><input type="file" ref={videoFileRef} /> </div>
                            <div><Button onClick={onClickUploadButton}>Upload</Button></div>
                            <AdminVideoList videos={videos} />
                            <AdminVideoAssignment videos={videos} className='mt-5' />
                        </div>

            }
        </div>
    );
}

export default AdminVideoSetup;
